import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import translations from '../i18n/translations';

const API = process.env.REACT_APP_API_URL || '/api';

export default function LoginPage({ onRegister }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [uiLang, setUiLang] = useState('cs');
  const [mode, setMode] = useState('login'); // 'login' | 'forgot'
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotStatus, setForgotStatus] = useState(''); // '' | 'loading' | 'sent'

  const t = (key) => {
    const keys = key.split('.');
    let val = translations[uiLang];
    for (const k of keys) val = val?.[k];
    return val ?? key;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch {
      setError(t('invalidCredentials'));
    } finally {
      setLoading(false);
    }
  };

  const handleForgot = async () => {
    if (!forgotEmail) return;
    setForgotStatus('loading');
    try {
      await fetch(`${API}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: forgotEmail }),
      });
    } catch (e) {}
    setForgotStatus('sent');
  };

  const forgotLabels = {
    cs: { title: 'Zapomenuté heslo', subtitle: 'Zadejte váš e-mail a pošleme vám odkaz na reset hesla.', btn: 'Odeslat odkaz', sent: 'Pokud e-mail existuje v systému, obdržíte odkaz na reset hesla.', back: '← Zpět na přihlášení', placeholder: 'vas@email.cz' },
    sk: { title: 'Zabudnuté heslo', subtitle: 'Zadajte váš e-mail a pošleme vám odkaz na reset hesla.', btn: 'Odoslať odkaz', sent: 'Ak e-mail existuje v systéme, dostanete odkaz na reset hesla.', back: '← Späť na prihlásenie', placeholder: 'vas@email.sk' },
    ro: { title: 'Parolă uitată', subtitle: 'Introduceți e-mailul dvs. și vă vom trimite un link de resetare.', btn: 'Trimite link', sent: 'Dacă e-mailul există în sistem, veți primi un link de resetare.', back: '← Înapoi la autentificare', placeholder: 'email@dvs.ro' },
  };
  const fl = forgotLabels[uiLang] || forgotLabels.cs;

  return (
    <div style={{ minHeight: '100vh', background: '#f0f2f5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Outfit', 'Segoe UI', sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 4px 32px rgba(0,0,0,0.10)', width: '100%', maxWidth: 420, overflow: 'hidden' }}>
        {/* Header */}
        <div style={{ background: 'linear-gradient(135deg, #0e76bc 0%, #0b5e96 100%)', padding: '32px 32px 28px', textAlign: 'center' }}>
          <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'center' }}>
            <img src="/Grandstreampartner.png" alt="Grandstream Partner Program" style={{ height: 70, borderRadius: 8 }} />
          </div>
          <h1 style={{ color: '#fff', margin: 0, fontSize: 22, fontWeight: 700 }}>
            {mode === 'forgot' ? fl.title : t('loginTitle')}
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.8)', margin: '6px 0 0', fontSize: 14 }}>
            {mode === 'forgot' ? fl.subtitle : t('loginSubtitle')}
          </p>
          <div style={{ marginTop: 16, display: 'flex', gap: 8, justifyContent: 'center' }}>
            {['cs', 'sk', 'ro', 'en', 'hu'].map(l => (
              <button key={l} onClick={() => setUiLang(l)} style={{
                background: uiLang === l ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.1)',
                border: '1px solid rgba(255,255,255,0.3)', borderRadius: 6, color: '#fff',
                padding: '3px 12px', fontSize: 12, cursor: 'pointer',
                fontWeight: uiLang === l ? 700 : 400, transition: 'all 0.2s',
              }}>{l.toUpperCase()}</button>
            ))}
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: '32px 32px 28px' }}>
          {mode === 'login' ? (
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: 18 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>{t('email')}</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="email"
                  style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 15, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }}
                  onFocus={e => e.target.style.borderColor = '#0e76bc'}
                  onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
              </div>
              <div style={{ marginBottom: 8 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>{t('password')}</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password"
                  style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 15, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }}
                  onFocus={e => e.target.style.borderColor = '#0e76bc'}
                  onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
              </div>
              <div style={{ textAlign: 'right', marginBottom: 20 }}>
                <button type="button" onClick={() => { setMode('forgot'); setForgotEmail(email); setForgotStatus(''); }}
                  style={{ background: 'none', border: 'none', color: '#0e76bc', cursor: 'pointer', fontSize: 13, fontFamily: 'inherit', padding: 0 }}>
                  {uiLang === 'cs' ? 'Zapomenuté heslo?' : uiLang === 'sk' ? 'Zabudnuté heslo?' : uiLang === 'ro' ? 'Parolă uitată?' : uiLang === 'hu' ? 'Elfelejtett jelszó?' : 'Forgot password?'}
                </button>
              </div>
              {error && (
                <div style={{ background: '#e8f4fc', border: '1px solid #b3d9f2', color: '#dc2626', borderRadius: 8, padding: '10px 14px', fontSize: 14, marginBottom: 18 }}>
                  {error}
                </div>
              )}
              <button type="submit" disabled={loading}
                style={{ width: '100%', padding: '12px', background: loading ? '#9ca3af' : 'linear-gradient(135deg, #0e76bc 0%, #0b5e96 100%)', color: '#fff', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}>
                {loading ? '...' : t('login')}
              </button>
            </form>
          ) : (
            <div>
              {forgotStatus === 'sent' ? (
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: 48, marginBottom: 16 }}>📧</div>
                  <p style={{ color: '#374151', fontSize: 14, lineHeight: 1.6, marginBottom: 24 }}>{fl.sent}</p>
                  <button onClick={() => setMode('login')}
                    style={{ background: 'linear-gradient(135deg, #0e76bc, #0b5e96)', color: '#fff', border: 'none', borderRadius: 8, padding: '12px 24px', fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
                    {fl.back.replace('← ', '')}
                  </button>
                </div>
              ) : (
                <>
                  <div style={{ marginBottom: 20 }}>
                    <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>{t('email')}</label>
                    <input type="email" value={forgotEmail} onChange={e => setForgotEmail(e.target.value)} placeholder={fl.placeholder}
                      style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e5e7eb', borderRadius: 8, fontSize: 15, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }}
                      onFocus={e => e.target.style.borderColor = '#0e76bc'}
                      onBlur={e => e.target.style.borderColor = '#e5e7eb'} />
                  </div>
                  <button onClick={handleForgot} disabled={!forgotEmail || forgotStatus === 'loading'}
                    style={{ width: '100%', padding: '12px', background: !forgotEmail || forgotStatus === 'loading' ? '#9ca3af' : 'linear-gradient(135deg, #0e76bc, #0b5e96)', color: '#fff', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700, cursor: !forgotEmail ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}>
                    {forgotStatus === 'loading' ? '...' : fl.btn}
                  </button>
                  <p style={{ textAlign: 'center', marginTop: 16 }}>
                    <button onClick={() => setMode('login')}
                      style={{ background: 'none', border: 'none', color: '#0e76bc', cursor: 'pointer', fontSize: 13, fontFamily: 'inherit' }}>
                      {fl.back}
                    </button>
                  </p>
                </>
              )}
            </div>
          )}
          {onRegister && (
            <div style={{ textAlign: 'center', marginTop: 16 }}>
              <span style={{ fontSize: 13, color: '#6b7280' }}>
                {uiLang === 'cs' ? 'Nemáte účet?' : uiLang === 'sk' ? 'Nemáte účet?' : uiLang === 'hu' ? 'Nincs fiókja?' : "Don't have an account?"}{' '}
              </span>
              <span onClick={onRegister} style={{ fontSize: 13, color: '#0e76bc', fontWeight: 700, cursor: 'pointer' }}>
                {uiLang === 'cs' ? 'Registrovat se' : uiLang === 'sk' ? 'Registrovať sa' : uiLang === 'hu' ? 'Regisztráció' : 'Register'}
              </span>
            </div>
          )}

          <div style={{ textAlign: 'center', marginTop: 24, paddingTop: 20, borderTop: '1px solid #f3f4f6' }}>
            <img src="/GSdistrilogo.png" alt="Grandstream Certified Distributor" style={{ height: 40, opacity: 0.8, marginBottom: 8 }} />
            <p style={{ fontSize: 11, color: '#9ca3af', margin: 0, lineHeight: 1.5 }}>
              Portál autorizovaného distributora.<br/>Nejedná se o oficiální stránky výrobce.
            </p>
            <p style={{ fontSize: 11, color: '#c9d1d9', margin: '6px 0 0' }}>
              © {new Date().getFullYear()} Grandstream Distributor
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
